var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as _ from "lodash";
import { AsyncRequestStatus } from "@ane/core/lib/models/IAsyncWrapper";
import { flightingApprovalUtils } from "./FlightingApprovalUtils.js";
import "../models/index.js";
import { compareIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { OperationCheckTypes } from "../models/OperationCheckModels.js";
import { GateState } from "../models/gates/models/gateState.js";
class GatingUtils {
  constructor() {
    __publicField(this, "TimedGate", "UnlockAfter Gate");
  }
  didGateCheckFail(gateResponse) {
    return gateResponse && gateResponse.status === AsyncRequestStatus.Failed;
  }
  isGateCheckCompleted(gateResponse) {
    return gateResponse && gateResponse.status === AsyncRequestStatus.Completed;
  }
  getActiveGatesOrDefault(gates, ...operationTypes) {
    let activeGates = [];
    if (this.isGateCheckCompleted(gates)) {
      activeGates = gates.data || [];
      if (operationTypes && operationTypes.length > 0) {
        activeGates = this.getGatesForOperations(activeGates, ...operationTypes);
      }
    }
    return activeGates;
  }
  getApprovalGate(gates, ...operationTypes) {
    const activeGates = this.getActiveGatesOrDefault(gates, ...operationTypes);
    return _.find(activeGates, (g) => flightingApprovalUtils.isApprovalGateByType(g.gateType));
  }
  getWaitingApprovalGates(entityType, entityId, friendlyName, gates) {
    const waitingApprovalGates = _.filter(
      gates,
      (gate) => this.isGateInWaiting(gate.state) && flightingApprovalUtils.isApprovalGateByType(gate.gateType)
    );
    return _.map(waitingApprovalGates, (gate) => this.getFlightingApprovalGate(entityType, entityId, friendlyName, gate));
  }
  isTimedGate(gateName) {
    return compareIgnoreCase(this.TimedGate, gateName);
  }
  getFlightingApprovalGate(entityType, entityId, friendlyName, gate) {
    return {
      EntityType: entityType,
      EntityId: entityId,
      FriendlyName: friendlyName,
      Gate: gate
    };
  }
  openGateApi(gateEntityId, fullGraph) {
    if (!gateEntityId) {
      return false;
    }
    const parseType = `parseType=${fullGraph ? "FullGraph" : "WithDescendants"}`;
    const aggregateParents = "aggregateParentGates=false";
    const gatingBaseUrl = EnvironmentService.endpoints.gatesService.url;
    const url = `${gatingBaseUrl}${gateEntityId}/gates/active?${parseType}&${aggregateParents}`;
    window.open(url, "_blank");
    return true;
  }
  getGateMessage(gate) {
    let message = gate.reason;
    if (!message) {
      message = "<no message>";
    }
    return message;
  }
  isOperationGated(gate, ...operationTypes) {
    return gate && gate.gateType && _.some(
      gate.gateType.gatedOperations,
      (gatedOp) => operationTypes.some((requestType) => compareIgnoreCase(gatedOp, OperationCheckTypes[requestType]))
    );
  }
  getGatesForOperations(gates, ...operationTypes) {
    if (!gates)
      return null;
    return !operationTypes || operationTypes.length === 0 || !gates ? gates : gates && gates.filter((g) => this.isOperationGated(g, ...operationTypes));
  }
  hasWaitingGates(gates) {
    const activeGates = this.getActiveGatesOrDefault(gates);
    return _.some(activeGates, (g) => this.isGateInWaiting(g.state));
  }
  getUpdateBlockingGates(progression, progressionStage) {
    const stageGates = this.getGatesForOperations(
      progressionStage.gates && progressionStage.gates.data || [],
      OperationCheckTypes.Update
    );
    const progressionGates = this.getGatesForOperations(
      progression.gates && progression.gates.data || [],
      OperationCheckTypes.Update
    );
    const stepGates = this.getGatesForOperations(
      progressionStage.stages && progressionStage.stages.reduce((previous, current) => {
        return previous.concat(current.gates && current.gates.data || []);
      }, new Array()),
      OperationCheckTypes.Update
    );
    const updateGates = stageGates.concat(progressionGates).concat(stepGates);
    return updateGates.filter((g) => this.isGateInWaiting(g.state));
  }
  isGateInWaiting(gateState) {
    return GateState[gateState] === GateState.Waiting;
  }
  getPropertyBag(resolutionMetadata) {
    if (resolutionMetadata && resolutionMetadata.propertyBag) {
      try {
        const propertyBag = JSON.parse(resolutionMetadata.propertyBag);
        if (propertyBag && typeof propertyBag === "object") {
          return propertyBag;
        }
      } catch (e) {
      }
    }
    return null;
  }
  buildBody(gate) {
    const status = `**Status:** ${gate.state}`;
    const type = `
**Type:** ${gate.gateType.name}`;
    const unlocksAt = !!gate.unlocksAt ? `
**Unlocks At:** ${new Date(gate.unlocksAt).toLocaleString()}` : "";
    const unlockAfter = !unlocksAt && !!gate.unlockAfter ? `
**Unlocks After:** ${gate.unlockAfter}` : "";
    const blockedOps = `
**Blocked Operations:** ${gate.gateType.gatedOperations.join(", ")}`;
    return `${status}${type}${unlocksAt}${unlockAfter}${blockedOps}
____
${this.getGateMessage(gate)}`;
  }
}
const gatingUtils = new GatingUtils();
export {
  GatingUtils,
  gatingUtils
};
//# sourceMappingURL=GatingUtils.js.map
